import React, { useState, useEffect } from 'react';
import { Button, Alert } from 'react-bootstrap';
import './CookieConsent.css';

const CookieConsent = () => {
    const [showConsent, setShowConsent] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setShowConsent(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setShowConsent(false);
        
        // Инициализируем Яндекс.Метрику после согласия
        if (typeof window !== 'undefined' && window.ym) {
            window.ym(102481250, 'init', {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true,
                ecommerce: "dataLayer"
            });
        }
    };

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'false');
        setShowConsent(false);
        
        // При отказе Метрика просто не инициализируется
        console.log('Пользователь отклонил cookies');
    };

    if (!showConsent) {
        return null;
    }

    return (
        <div className="cookie-consent-overlay">
            <div className="cookie-consent-container">
                <Alert variant="info" className="cookie-consent-alert">
                    <div className="cookie-consent-content">
                        <h6 className="mb-2">🍪 Использование cookies</h6>
                        <p className="mb-3">
                            Мы используем cookies и Яндекс.Метрику для улучшения работы сайта и анализа посещений. 
                            Продолжая использовать сайт, вы даёте согласие на использование этих технологий.
                        </p>
                        <div className="cookie-consent-buttons">
                            <Button 
                                variant="primary" 
                                size="sm" 
                                onClick={handleAccept}
                                className="me-2"
                            >
                                Принять
                            </Button>
                            <Button 
                                variant="outline-secondary" 
                                size="sm" 
                                onClick={handleDecline}
                            >
                                Отклонить
                            </Button>
                        </div>
                    </div>
                </Alert>
            </div>
        </div>
    );
};

export default CookieConsent;